import { render, staticRenderFns } from "./shjefj.vue?vue&type=template&id=20f38ce8&scoped=true&"
import script from "./shjefj.vue?vue&type=script&lang=js&"
export * from "./shjefj.vue?vue&type=script&lang=js&"
import style0 from "./shjefj.vue?vue&type=style&index=0&id=20f38ce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f38ce8",
  null
  
)

export default component.exports